module.exports = __webpack_public_path__ + "img/view.99139562.svg";